var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore10945791(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.103,
    height: 40.882,
    viewBox: "0 0 48.103 40.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "store_10945791",
    transform: "translate(0 -38.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61742",
    "data-name": "Path 61742",
    d: "M41.572,38.429H6.53L0,50.1v.489a6.038,6.038,0,0,0,3.937,5.641V75.263a4.057,4.057,0,0,0,4.048,4.048H40.118a4.057,4.057,0,0,0,4.048-4.048V56.231A6.037,6.037,0,0,0,48.1,50.59l0-.489Z",
    fill: "#d3dbef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61743",
    "data-name": "Path 61743",
    d: "M41.572,38.429H6.53L0,50.706v.514a6.174,6.174,0,0,0,6.012,6.324,6.174,6.174,0,0,0,6.012-6.324,6.175,6.175,0,0,0,6.014,6.325,6.175,6.175,0,0,0,6.014-6.325,6.174,6.174,0,0,0,6.012,6.324,6.174,6.174,0,0,0,6.012-6.324,6.02,6.02,0,1,0,12.024,0l0-.514Z",
    transform: "translate(0)",
    fill: "#ffbc5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61744",
    "data-name": "Path 61744",
    d: "M256,50.706h12.647l-3.012-12.277H256Z",
    transform: "translate(-232.364)",
    fill: "#e05555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61745",
    "data-name": "Path 61745",
    d: "M15.641,38.429H6.869L0,50.706H12.647Z",
    transform: "translate(0)",
    fill: "#e05555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61746",
    "data-name": "Path 61746",
    d: "M112.081,287.535H122.4v18.384H112.081Z",
    transform: "translate(-101.691 -226.608)",
    fill: "#cc8679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61747",
    "data-name": "Path 61747",
    d: "M287.656,287.535H298.75v9.931H287.656Z",
    transform: "translate(-261.024 -226.067)",
    fill: "#8491c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61748",
    "data-name": "Path 61748",
    d: "M112.081,287.535H122.4v18.384H112.081Z",
    transform: "translate(-101.691 -226.608)",
    fill: "#cc8679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61749",
    "data-name": "Path 61749",
    d: "M287.656,287.535H298.75v9.931H287.656Z",
    transform: "translate(-261.024 -226.067)",
    fill: "#8491c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61750",
    "data-name": "Path 61750",
    d: "M195.543,287.535h2.075v18.384h-2.075Z",
    transform: "translate(-177.212 -226.608)",
    fill: "#bf7267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61751",
    "data-name": "Path 61751",
    d: "M378.919,287.535h2.075v9.931h-2.075Z",
    transform: "translate(-343.398 -226.067)",
    fill: "#6c80ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61752",
    "data-name": "Path 61752",
    d: "M12.647,163.179v-.514H0v.514a6.324,6.324,0,1,0,12.648,0Z",
    transform: "translate(0 -112.678)",
    fill: "#c63e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61753",
    "data-name": "Path 61753",
    d: "M140.634,163.179v-.514H127.986v.514h0a6.325,6.325,0,1,0,12.65,0Z",
    transform: "translate(-116.169 -112.678)",
    fill: "#ef9d3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61754",
    "data-name": "Path 61754",
    d: "M268.647,162.664H256v.514a6.324,6.324,0,1,0,12.648,0Z",
    transform: "translate(-232.364 -112.677)",
    fill: "#c63e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61755",
    "data-name": "Path 61755",
    d: "M396.632,163.179v-.514H383.985v.514a6.324,6.324,0,1,0,12.648,0Z",
    transform: "translate(-348.533 -112.678)",
    fill: "#ef9d3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61756",
    "data-name": "Path 61756",
    d: "M410.267,228.3v19.63a4.267,4.267,0,0,1-4.258,4.258h2.075a4.267,4.267,0,0,0,4.258-4.258V227.908A6.261,6.261,0,0,1,410.267,228.3Z",
    transform: "translate(-368.38 -172.874)",
    fill: "#bfcae2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore10945791);
export default __webpack_public_path__ + "static/media/store_10945791.fff5b31122d93a1cbff2b2db3f1d2bb2.svg";
export { ForwardRef as ReactComponent };